import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized')({
  beforeLoad: async ({ context: { store }, location }) => {
    const storeState = store.getState().onboarding
    const isInitialized = storeState.appInitialized
    if (!isInitialized) {
      redirect({ to: '/', throw: true, search: location.search })
    }
  },
})
